import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import productData from "../data/productData";
import useScrollAnimation from "../../hooks/UseScrollAnimation";

const ProductCategoryFilter = ({ categories, selectedCategory, onCategoryChange }) => (
    <div className="btmAni25002 flex items-center gap-[7px] flex-wrap">
        {categories.map(category => (
            <button
                key={category}
                className={`capitalize px-[30px] py-[7px] rounded-[4px] text-[14px] font-bold ${selectedCategory === category ? 'bg-[#017E89] text-white' : 'bg-white text-[#017E89] shadow-md shadow-[#00000024]'}`}
                onClick={() => onCategoryChange(category)}>
                {category}
            </button>
        ))}
    </div>
);

const ProductSubCategoryFilter = ({ subCategories, selectedSubCategory, onSubCategoryChange }) => (
    <div className="flex items-center gap-[7px] flex-wrap">
        {subCategories.map(sub => (
            <button
                key={sub}
                className={`capitalize px-[30px] py-[7px] rounded-[4px] text-[14px] font-bold ${selectedSubCategory === sub ? 'bg-[#017E89] text-white' : 'bg-white text-[#017E89] shadow-md shadow-[#00000024]'}`}
                onClick={() => onSubCategoryChange(sub)}>
                {sub}
            </button>
        ))}
    </div>
);

const ProductCard = ({ product }) => (
    <div className="w-100 btmAni25002 w-[32%] rounded-[8px] shadow-md shadow-[#00000024]">
        <div className="w-[100%] h-[260px]">
            <img className="w-full h-full rounded-t-[8px]" src={product.image} alt={product.title} />
        </div>
        <div className="p-[20px] flex flex-col gap-[25px] justify-between">
            <div className="flex flex-col gap-[5px]">
                <div className="text-[20px] text-[#017E89] font-bold">{product.title}</div>
                <p className="text-[13px]">{product.description.length > 50 ? `${product.description.substring(0, 100)}...` : product.description}</p>
            </div>
            <Link to={`/productsDetails/${product.id}`}>
                <span className="capitalize font-bold">More Details</span>
                <img className="h-auto" src={require("../../assets/icons/twoLines.svg").default} alt="" />
            </Link>
        </div>
    </div>
);

export default function Product() {
    const { t } = useTranslation();
    useScrollAnimation();
    const [selectedCategory, setSelectedCategory] = useState("Show All");
    const [selectedSubCategory, setSelectedSubCategory] = useState("");

    const categories = ['Show All', 'Supplement', 'Prescribed medication', 'Cosmetic'];
    const subCategories = ["Perfect", "Vita Mare"];

    const filterProducts = () => {
        if (selectedCategory === "Show All") return productData;
        if (selectedCategory === "Cosmetic" && selectedSubCategory) {
            return productData.filter(el => el.category === "Cosmetic" && el.subCategory === selectedSubCategory);
        }
        return productData.filter(el => el.category === selectedCategory);
    };

    return (
        <>
            <section className="landingpages">
                <div className="container h-full flex flex-col items-center justify-center text-center">
                    <div className="btmAni1256 text-[#017E89] font-bold text-[35px] capitalize">{t("Products")}</div>
                    <div className="btmAni2000 flex items-center gap-[5px] fonbold">
                        <Link to={'/'}>{t("Home")}</Link> - <span className="text-[#017E89] capitalize">{t("Products")}</span>
                    </div>
                </div>
            </section>

            <section className="relative py-[40px]">
                <div className="container flex flex-col gap-[50px]">
                    <div className="f-col flex flex-col gap-[20px] flex-wrap">
                        <ProductCategoryFilter
                            categories={categories}
                            selectedCategory={selectedCategory}
                            onCategoryChange={(category) => { setSelectedCategory(category); setSelectedSubCategory(""); }}
                        />

                        {selectedCategory === "Cosmetic" && (
                            <ProductSubCategoryFilter
                                subCategories={subCategories}
                                selectedSubCategory={selectedSubCategory}
                                onSubCategoryChange={setSelectedSubCategory}
                            />
                        )}
                    </div>

                    <div className="flex gap-[10px] flex-wrap ">
                        {filterProducts().map((product) => (
                            <ProductCard key={product.id} product={product} />
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
}
